import { render, staticRenderFns } from "./ProjectMod.vue?vue&type=template&id=3d2a2812&scoped=true"
import script from "./ProjectMod.vue?vue&type=script&lang=js"
export * from "./ProjectMod.vue?vue&type=script&lang=js"
import style0 from "./ProjectMod.vue?vue&type=style&index=0&id=3d2a2812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a2812",
  null
  
)

export default component.exports